import { useEffect, useState } from 'react'

// 再生成中の進捗ステップ (0→3) をダミー進行させる state を切り出したもの。
// isRegenerating の立ち上がり (props 変化) を render 中 setState で検知して step を 0 に reset
// する (React 公式 "Adjusting state when props change" pattern)。以後 dwell 毎に step を進める。
export const useRegenerateProgress = (
  isRegenerating: boolean
): 0 | 1 | 2 | 3 => {
  const [regenStep, setRegenStep] = useState<0 | 1 | 2 | 3>(0)
  const [prevRegen, setPrevRegen] = useState(false)
  if (prevRegen !== isRegenerating) {
    setPrevRegen(isRegenerating)
    if (isRegenerating) setRegenStep(0)
  }
  useEffect(() => {
    if (!isRegenerating) return
    if (regenStep >= 3) return
    const dwell = 1500 + (Math.random() * 2 - 1) * 500
    const t = window.setTimeout(() => {
      setRegenStep((s) => (s < 3 ? ((s + 1) as 0 | 1 | 2 | 3) : s))
    }, dwell)
    return () => window.clearTimeout(t)
  }, [isRegenerating, regenStep])
  return regenStep
}
